/* eslint-disable linebreak-style */
import { commonClient, publicCommonClient } from '../clients';

const bookingInterface = {
  getOffers: async (centreId, providerId, serviceId, bookingId, dateStart, dateEnd) => {
    const { data: offers } = await publicCommonClient.get(
      `/api/providers/${providerId}/centres/${centreId}/services-day-offer?start=${dateStart}&end=${dateEnd}&bookingId=${bookingId}`,
    );

    return offers;
  },
  bookAppointment: async (
    centreId,
    providerId,
    serviceId,
    userId,
    date,
    startTime,
    endTime,
    endBufferTime,
  ) => {
    const { data: offers } = await commonClient.post('/api/appointments', {
      centreId,
      dirPartnerId: centreId,
      providerId,
      booking_fk: serviceId,
      consumerId: userId,
      createdByUserId: userId,
      date,
      startTime,
      endTime,
      description: '',
      status: 'CONFIRMED',
      endBufferTime,
    });

    return offers;
  },
};

export default bookingInterface;
